import React, { useEffect, useState } from "react";
import { Directions, translationConstants } from "../../../../constants";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { EventActions, authActions } from "../../../../redux/actions";
import InfiniteScroll from "react-infinite-scroll-component";
import { getUserPayload } from "../../../../system";
import CustomModal from "../../../../shared/components/CustomModal/CustomModal";
import DeleteModal from "../../../../shared/components/Modals/DeleteModal";
import {
  loadingIndicator,
  dataEndMessage,
} from "../../../../shared/utilitiies";
import TimezoneDisplayText from "../../../../shared/components/TimezoneDisplayText/TimezoneDisplayText";
import MyEventCard from "./MyEventCard/MyEventCard";

const defaultQueryExpression = "id != null ";

//-------initial gridstate
const initialGridState = {
  length: 7,
  search: null,
  pageNumber: 1,
  orderBy: "startDate desc",
  filterQuery: defaultQueryExpression,
};

const MyEvents = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const userPayload = getUserPayload();

  const [gridState, setGridState] = useState(initialGridState);
  const [eventPageData, setEventPageData] = useState([]);
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [eventToDelete, setEventToDelete] = useState("");
  const [cityFilter, setCityFilter] = useState("");

  const cities = useSelector((state) => state.LoginReducer.cities);
  const isViewModalOpen = useSelector((state) => state.eventReducer.openModal);
  const events = useSelector((state) => state.eventReducer.myEvents?.pageData);

  const direction = useSelector(
    (state) => state.LanguageChangeReducer.direction
  );

  useEffect(() => {
    dispatch(
      EventActions.getPaginatedMyEvents(gridState, userPayload?.user?.id)
    );
  }, [gridState]);

  useEffect(() => {
    setEventPageData(events);
  }, [events]);

  const handleCityChange = (event) => {
    const updatedGridState = { ...gridState };
    const cityId = event.target.value;
    setCityFilter(cityId);

    if (cityId) {
      updatedGridState.filterQuery = `cityId = ${cityId} || spotInfo.spotCityId = ${cityId}`;
    } else {
      updatedGridState.filterQuery = defaultQueryExpression; // Or reset to default if cityId is empty
    }

    setGridState(updatedGridState);
  };

  const handleClearFilters = () => {
    setCityFilter("");
    setGridState({
      ...gridState,
      filterQuery: defaultQueryExpression,
    });
  };

  const getMoreEvents = () => {
    const updatedGridState = { ...gridState, length: gridState.length + 7 };
    setGridState(updatedGridState);
  };

  useEffect(() => {
    dispatch(authActions.fetchCities(process.env.REACT_APP_Country_Id));
  }, [dispatch]);

  const onCancelRegistration = (heading, row) => {
    setTitle(heading);
    setMessage(
      `${t(translationConstants.ARE_YOU_SURE_YOU_WANT_TO_CANCEL_REGISTRATION)}`
    );
    setEventToDelete(row);
    dispatch(EventActions.toggleViewModal(!isViewModalOpen));
  };

  const cancelRegistration = (data) => {
    if (eventToDelete?.isPublicRegistrationAllowed) {
      dispatch(
        EventActions.cancelPublicEventRegistration(
          userPayload?.user?.id,
          gridState,
          eventToDelete?.id
        )
      );
    } else {
      dispatch(
        EventActions.cancelPrivateEventRegistration(
          userPayload?.user?.id,
          gridState,
          eventToDelete?.id,
          "MyEventPage"
        )
      );
    }
    dispatch(EventActions.toggleViewModal(false));
  };

  return (
    <div className="container pe-md-3">
      <div className="row px-2 px-md-0">
        <div className="col-12 col-md-6">
          <p className="UserTabHeading">{t(translationConstants.MY_EVENTS)}</p>
        </div>
        <div className="col-12 col-md-6 d-md-flex gap-2 justify-content-end align-items-center">
          <div className="row w-100 justify-content-end">
            <div
              className={`${
                !cityFilter ? "mx-0 mx-md-1" : ""
              } col-12 col-md-6 d-flex justify-content-center justify-content-md-end align-items-center`}
            >
              <Form.Select
                className="custom-select-icon filter-style"
                aria-label="Default select example"
                onChange={handleCityChange}
                value={cityFilter}
              >
                <option value="">
                  {t(translationConstants.PLEASE_SELECT_A_CITY)}
                </option>
                {cities?.map((city) => (
                  <option key={city.id} value={city.id}>
                    {direction === Directions.rtl
                      ? city?.arabicName || city?.name
                      : city?.name}
                  </option>
                ))}
              </Form.Select>
            </div>
            {cityFilter && (
              <div className="col-12 col-md-2 d-flex justify-content-center justify-content-md-end align-items-center mx-0 mx-md-3">
                <div className="cancel-filter" onClick={handleClearFilters}>
                  {t(translationConstants.CLEAR_FILTERS)}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <TimezoneDisplayText />
      <div className="row">
        <InfiniteScroll
          dataLength={eventPageData?.length ?? 0}
          next={getMoreEvents}
          hasMore={
            eventPageData?.length % 7 === 0 && eventPageData?.length !== 0
              ? true
              : false
          }
          loader={loadingIndicator(t)}
          endMessage={dataEndMessage(t, eventPageData)}
          style={{ overflow: "hidden" }}
          scrollableTarget={"main-container"}
        >
          <div className="row m-0 w-100">
            {eventPageData?.map((event) => {
              const city = cities?.find((s) => s.id === event?.cityId);
              return (
                <MyEventCard
                  event={event}
                  city={city}
                  onCancelRegistration={onCancelRegistration}
                />
              );
            })}
          </div>
        </InfiniteScroll>
      </div>
      <CustomModal
        scrollable={true}
        size="md"
        setShow={onCancelRegistration}
        show={isViewModalOpen}
        customClass="view-user-modal"
      >
        <DeleteModal
          title={title}
          message={message}
          dataToDelete={eventToDelete}
          removeRowData={cancelRegistration}
          onCancel={() =>
            dispatch(EventActions.toggleViewModal(!isViewModalOpen))
          }
        />
      </CustomModal>
    </div>
  );
};

export default MyEvents;
